module.exports = __webpack_public_path__ + "img/album02_03.0cdda952.jpg";